// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search__wrapper {
  margin: 0 14px;
  padding-bottom: 4px;
}

.search__title {
  display: flex;
  align-items: center;
  color: var(--primary);
  margin: 8px 0 4px 0;
  font-size: 1.6rem;
  font-weight: 600;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  padding-bottom: 6px;
}

.search__container__row {
  display: block;
  align-items: left;
}

.search__admin__title{
  font-weight: 500;
  font-size: var(--caption);
  margin-bottom: 3px;
  color: #263238;
}

.search__autocomplete__container {
  width: 100%;
}
.search__autocomplete__container div {
  height: auto !important;
}

.search__footer__row {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-bottom: 4px;
  margin-top: 8px;
}

.search__container__btn {
  font-style: normal;
  font-weight: normal;
  font-size: var(--subheader);
  width: 150px;
  color: #000 !important;
  letter-spacing: 0;
  text-transform: none !important;
  border-radius: 4px;
  border: none;
  margin: 0;
}

.search__container__btn:hover {
  background-color: #F1F0EF;
}
`, "",{"version":3,"sources":["webpack://./src/components/Modules/AdminManagement/searchTab/Search/AdminSearch.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".search__wrapper {\n  margin: 0 14px;\n  padding-bottom: 4px;\n}\n\n.search__title {\n  display: flex;\n  align-items: center;\n  color: var(--primary);\n  margin: 8px 0 4px 0;\n  font-size: 1.6rem;\n  font-weight: 600;\n  border-bottom: 1px solid rgba(0,0,0,0.08);\n  padding-bottom: 6px;\n}\n\n.search__container__row {\n  display: block;\n  align-items: left;\n}\n\n.search__admin__title{\n  font-weight: 500;\n  font-size: var(--caption);\n  margin-bottom: 3px;\n  color: #263238;\n}\n\n.search__autocomplete__container {\n  width: 100%;\n}\n.search__autocomplete__container div {\n  height: auto !important;\n}\n\n.search__footer__row {\n  display: flex;\n  justify-content: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  margin-top: 8px;\n}\n\n.search__container__btn {\n  font-style: normal;\n  font-weight: normal;\n  font-size: var(--subheader);\n  width: 150px;\n  color: #000 !important;\n  letter-spacing: 0;\n  text-transform: none !important;\n  border-radius: 4px;\n  border: none;\n  margin: 0;\n}\n\n.search__container__btn:hover {\n  background-color: #F1F0EF;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
